import { ServiceAddress } from './service-address';
import { Ambit } from './ambit';
import { Assignee, FilterDate, Filters } from './filters';
import { Route, Task } from './task';
import { CloseTaskActions } from './close-task-actions';
import { MasterDataConfiguration } from './master-data-configuration';
import { RejectTaskActions } from './reject-task-actions';
import { TaskActions } from './task-actions';
import { ConfirmCloseTaskActions } from './confirm-close-task-actions';
import { ConfirmRejectTaskActions } from './confirm-reject-task-actions';
import { WorkType } from './work-type';
import { Priority } from './priority';
import { TaskStatus } from './task-status';
import { Nullable } from 'src/core/common/domain/types/types';

export class MasterData {
  constructor(
    public readonly service_addresses: Array<ServiceAddress>,
    public readonly filters: Filters,
    public readonly ambitList: Array<Ambit>,
    public readonly tasks: Array<Task>,
    public readonly availableActions: Nullable<TaskActions[]>,
    public readonly closeTaskActions: CloseTaskActions,
    public readonly confirmCloseTaskActions: ConfirmCloseTaskActions,
    public readonly rejectTaskActions: RejectTaskActions,
    public readonly confirmRejectTaskActions: ConfirmRejectTaskActions,
    public readonly configuration: MasterDataConfiguration,
    public readonly lastDownloadCausedError: boolean
  ) {}

  dates(): Array<FilterDate> {
    return this.filters.dates;
  }

  workTypes(): Array<WorkType> {
    return this.filters.workTypes;
  }

  statuses(): Array<TaskStatus> {
    return this.filters.statuses;
  }

  assignees(): Array<Assignee> {
    return this.filters.assignees;
  }

  priorities(): Array<Priority> {
    return this.filters.priorities;
  }

  routes(): Array<Route> {
    return this.filters.routes;
  }
}
